import styled from 'styled-components';

export const StyledComp = styled.section<{
  alignElement: string;
  imgAlignment?: string;
  isMobileView?: boolean;
  logoIcon?: string;
}>`
  padding: 0 0 80px;
  overflow: hidden;
  @media (min-width: 992px) {
    padding-top: 90px;
    padding-bottom: 90px;
  }
  .feature-lt-text {
    font: inherit;
    line-height: inherit;
  }
  .lt-commit-image {
    position: relative;
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    .lt-commit-image {
      padding-right: 54px;
    }
  }
  @media (max-width: 991px) {
    .lt-commit-image {
      justify-content: center;
    }
  }
  .lt-commit-image.lt-stretch-blue::before,
  .lt-commit-image.lt-stretch-blue::after,
  .lt-commit-image.lt-stretch-purple::before,
  .lt-commit-image.lt-stretch-purple::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .lt-commit-image.lt-stretch-blue::before,
  .lt-commit-image.lt-stretch-purple::before {
    left: calc(-100% + 8px);
  }
  @media (min-width: 768px) {
    .lt-commit-image.lt-stretch-blue::before,
    .lt-commit-image.lt-stretch-purple::before {
      left: calc(-100% + 68px);
    }
  }
  @media (min-width: 992px) {
    .lt-commit-image.lt-stretch-blue::before,
    .lt-commit-image.lt-stretch-purple::before {
      left: calc(-100% + 8px);
    }
  }
  @media (min-width: 1200px) {
    .lt-commit-image.lt-stretch-blue::before,
    .lt-commit-image.lt-stretch-purple::before {
      left: calc(-100% + 8px);
    }
  }
  @media (min-width: 1552px) {
    .lt-commit-image.lt-stretch-blue::before,
    .lt-commit-image.lt-stretch-purple::before {
      left: calc(-100% - 199px);
    }
  }
  .lt-commit-image.lt-stretch-blue::after,
  .lt-commit-image.lt-stretch-purple::after {
    right: calc(-100% + 8px);
  }
  @media (min-width: 768px) {
    .lt-commit-image.lt-stretch-blue::after,
    .lt-commit-image.lt-stretch-purple::after {
      right: calc(-100% + 68px);
    }
  }
  @media (min-width: 992px) {
    .lt-commit-image.lt-stretch-blue::after,
    .lt-commit-image.lt-stretch-purple::after {
      display: none;
    }
  }
  .lt-commit-image.lt-stretch-blue::before,
  .lt-commit-image.lt-stretch-blue::after {
    background-color: var(--color-blue);
  }
  .lt-commit-image.lt-stretch-purple::before,
  .lt-commit-image.lt-stretch-purple::after {
    background-color: var(--color-purple);
  }
  .lt-commit-featured-img {
    width: 100%;
    height: auto;
  }
  .lt-commit-text {
    text-align: center;
    padding-left: 25px;
    padding-right: 25px;
    margin-top: 40px;
  }
  .lt-commit-text .lt-title-2 em {
    font-family: 'AldineforMarriott-lt-italic';
    font-weight: 500;
  }
  @media (min-width: 992px) {
    .lt-commit-text {
      text-align: start;
      margin-top: 0;
    }
  }
  @media (max-width: 991px) {
    .lt-commit-text {
      &.text-left {
        text-align: center !important;
      }
    }
  }
  @media (min-width: 1552px) {
    .lt-commit-text {
      padding-left: 40px;
    }
  }
  @media (max-width: 767px) {
    .lt-title-2 br {
      display: none;
    }
  }
  .lt-kicker-1 {
    align-self: center;
  }
  @media (min-width: 992px) {
    .lt-kicker-1 {
      align-self: flex-start;
    }
  }
  .lt-commit-featured {
    padding-top: 40px;
    .card-layered {
      border-radius: 0;
    }
    .card-layered-header {
      color: var(--color-white);

      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      //  margin-top: -3px;
    }
    .chevronContainer.icon-m::before {
      color: var(--color-white);
      font-weight: 400;
    }
    .chevronContainer.icon-m::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 45%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
      pointer-events: none;
    }

    .card-layered__content .card-text-wrapper .card-texts {
      background: none;
    }
    .t-overline-overlay {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;

      text-transform: uppercase;
      letter-spacing: 1.3px;

      color: var(--color-white);
    }
    .card-text-wrapper {
      z-index: 1;
    }
    .lt-commit-item {
      height: 100%;
    }
    .links-section {
      padding-bottom: 0 !important;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }
  }

  .lt-commit-featured .lt-credit-line {
    position: absolute;
    font-size: 12px;
  }
  .lt-commit-featured .card-layered {
    display: block;
    position: relative;
    height: 100%;
  }
  .lt-commit-featured ul {
    flex-direction: column;
    gap: 33px;
    padding-bottom: 0 !important;

    li {
      margin-left: 0 !important;
    }
  }
  .lt-commit-featured .lt-featured-img::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 45%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    pointer-events: none;
  }
  .lt-commit-featured .lt-featured-img .lt-unicef-logo {
    position: absolute;
    width: 90px;
    left: 22px;
    top: 5px;
  }
  .lt-commit-featured .lt-featured-img .lt-img-header {
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 10px;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    z-index: 1;
  }
  .lt-commit-featured .lt-featured-img .lt-img-header .lt-title-6 {
    margin: 0;
  }
  .lt-commit-featured .lt-featured-img .lt-img-header .lt-kicker-3,
  .lt-commit-featured .lt-featured-img .lt-img-header .lt-title-6 {
    color: var(--color-white);
  }
  .lt-commit-featured .lt-featured-img .lt-img-header .lt-kicker-3 {
    margin-bottom: 5px;
  }
  .lt-commit-featured .card-layered img {
    height: 100%;
    object-fit: cover;
  }
  .lt-commit-featured span[class*='brand-logo'] {
    position: absolute;
    top: 5px;
    left: 22px;
    color: var(--color-white);
  }
  .lt-commit-featured .lt-featured-img .arrow-right,
  .lt-commit-featured .lt-featured-img .play-button {
    position: absolute;
    background-color: transparent;
    display: inline-block;
    bottom: 0;
    right: 10px;
  }
  .lt-commit-featured .lt-links .lt-kicker-3 {
    color: var(--color-black);
  }
  .links-section .lt-kicker-3 {
    font-family: inherit;
  }
  .lt-links {
    margin-top: 49px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    & > div {
      width: 100%;
      height: 100%;
      & > div {
        height: 100%;
      }
    }
  }
  @media (max-width: 400px) {
    .lt-commit-featured .lt-featured-img {
      height: 250px;
    }
    .lt-commit-featured .lt-featured-img .play-button {
      position: relative;
      width: 50px;
      padding-left: 0;
      right: unset;
      padding-top: 10px;
    }
  }
  .lt-auth-links {
    .card-layered {
      border-radius: 0;
    }
  }
  @media (min-width: 992px) {
    &.lt-commit .lt-links {
      flex-direction: row;
      gap: 33px;
      margin-top: 80px;
      //justify-content: center;
    }
    &.lt-commit .lt-links .lt-kicker-3 {
      margin-bottom: 20px;
    }

    .lt-commit-featured .lt-featured-img::after {
      margin-right: 10px;
    }
    .lt-commit-featured .card-layered .lt-img-header {
      bottom: 20px;
    }
    .lt-commit-featured {
      padding-top: 80px;
    }
    .lt-commit-featured .lt-links {
      flex-direction: column !important;
      margin-top: 0;
    }
    .lt-commit-featured .lt-featured-img .arrow-right,
    .lt-commit-featured .lt-featured-img .play-button {
      right: 30px;
    }
  }
  &.lt-commit .lt-commit-unicef,
  &.lt-commit .lt-commit-featured-img {
    height: auto;
  }
  @media (min-width: 1552px) {
    &.lt-commit .lt-commit-featured-img {
      margin-left: -207px;
      width: 760px;
    }
  }

  .lt-unicef-outreach .image-cta-wrapper .credit-line-wrapper {
    position: absolute;
    width: fit-content;
    bottom: 0;
    z-index: 100;
  }
  .lt-unicef-outreach .image-cta-wrapper .credit-line-wrapper.left {
    left: 10px;
  }
  .lt-unicef-outreach .image-cta-wrapper .credit-line-wrapper.right {
    right: 10px;
  }
  .lt-unicef-outreach .image-cta-wrapper .credit-line-wrapper .credit-line {
    color: var(--color-white);
    font-size: 12px;
  }
  &.lt-unicef-programs {
    padding-top: 0;
    &.lt-commit .lt-commit-featured-img {
      margin-left: 0;
      width: 100%;
    }
    .lt-image img {
      width: 100%;
    }
    .row.lt-image-wrapper,
    .row > * {
      flex-shrink: 0;
      width: 100%;
      max-width: 100%;
      margin-top: 0;
    }
  }
  @media (min-width: 768px) {
    &.lt-unicef-programs .lt-image-wrapper {
      padding-bottom: 35px;
    }
  }
  @media (min-width: 992px) {
    &.lt-unicef-programs .lt-image-wrapper {
      padding-bottom: 75px;
    }
  }
  @media (max-width: 1200px) {
    &.lt-unicef-programs .lt-commit-text {
      margin-left: 0;
      padding-top: 40px !important;
    }
  }
  .lt-image-wrapper .play-button {
    position: absolute;
    left: 50%;
    padding: 0;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    transform: translate(-50%, 0px);
    top: 40%;
  }
`;
